/* ONE — Scroll reveal animations
   IntersectionObserver détecte quand un élément entre dans le viewport,
   ajoute .is-revealed pour déclencher la transition CSS.
   Marche avec prefers-reduced-motion (skipped si user veut moins de motion). */
(function(){
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('.one [class*="__title"],.one [class*="__intro"],.one [class*="__card"],.one [class*="__step"],.one [class*="__item"],.one [class*="__slide"],.one .one-h1,.one .one-h2,.one .one-h3,.one .one-lede,.one .one-eyebrow,.one-reveal').forEach(function(el){ el.classList.add('is-revealed'); });
    return;
  }
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.style.setProperty('--one-reveal-disabled', '1');
    document.querySelectorAll('.one').forEach(function(el){ el.querySelectorAll('*').forEach(function(c){ c.classList.add('is-revealed'); }); });
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('is-revealed');
        io.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px -80px 0px', threshold: 0.08 });

  function observe(){
    var selectors = [
      '.one [class*="__title"]',
      '.one [class*="__intro"]',
      '.one [class*="__card"]',
      '.one [class*="__step"]',
      '.one [class*="__item"]',
      '.one [class*="__slide"]',
      '.one [class*="__lede"]',
      '.one [class*="__ctas"]',
      '.one [class*="__cta"]',
      '.one [class*="__eyebrow"]',
      '.one [class*="__sub"]',
      '.one [class*="__body"]',
      '.one [class*="__pills"]',
      '.one [class*="__media"]',
      '.one .one-h1',
      '.one .one-h2',
      '.one .one-h3',
      '.one .one-lede',
      '.one .one-eyebrow',
      '.one-reveal',
      /* Sections complètes : ajoute .is-revealed sur la section elle-même */
      '.one-creatrice',
      '.one-reservation',
      '.one-galerie__card',
      '.one-products__card',
      '.one-cocreate__step'
    ];
    document.querySelectorAll(selectors.join(',')).forEach(function(el){
      // Skip hero (déjà visible)
      if (el.closest('.one-banner-video') || el.closest('.one-coll-hero')) {
        el.classList.add('is-revealed');
        return;
      }
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observe);
  } else {
    observe();
  }

  // Re-observe new elements (Shopify section reload, etc)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', observe);
  }

  // Manifesto cascade — observe the grid wrapper to add .is-visible when in view
  var ioGrid = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('is-visible');
        ioGrid.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px 0px 0px', threshold: 0.05 });

  function observeManifestoGrids(){
    document.querySelectorAll('.one-manifesto__grid').forEach(function(g){
      // Si déjà visible au chargement, déclenche tout de suite
      var rect = g.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        setTimeout(function(){ g.classList.add('is-visible'); }, 200);
      } else {
        ioGrid.observe(g);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeManifestoGrids);
  } else {
    observeManifestoGrids();
  }

  // Citation — "qui se peint" mot par mot
  // Découpe le texte de la citation en spans .word + applique animation au reveal
  function setupCitationPaint(){
    document.querySelectorAll('.one-citation__quote').forEach(function(q){
      if (q.dataset.painted === '1') return;
      q.dataset.painted = '1';
      // Wrap each word in a span
      var html = q.innerHTML;
      // On parse innerHTML pour préserver <br>, <em>, <strong>
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      function wrapTextNodes(node){
        var i = 0;
        while (i < node.childNodes.length) {
          var child = node.childNodes[i];
          if (child.nodeType === 3) {
            var text = child.textContent;
            var parts = text.split(/(\s+)/);
            var frag = document.createDocumentFragment();
            parts.forEach(function(p){
              if (/^\s+$/.test(p)) {
                frag.appendChild(document.createTextNode(p));
              } else if (p.length > 0) {
                var span = document.createElement('span');
                span.className = 'one-word';
                span.textContent = p;
                frag.appendChild(span);
              }
            });
            child.parentNode.replaceChild(frag, child);
            i += parts.filter(Boolean).length;
          } else if (child.nodeType === 1) {
            wrapTextNodes(child);
            i++;
          } else {
            i++;
          }
        }
      }
      wrapTextNodes(tmp);
      q.innerHTML = tmp.innerHTML;
      // Distribute delays
      var words = q.querySelectorAll('.one-word');
      words.forEach(function(w, idx){
        w.style.setProperty('--word-delay', (idx * 80) + 'ms');
      });
    });
  }

  var ioQuote = new IntersectionObserver(function(entries){
    entries.forEach(function(e){
      if (e.isIntersecting) {
        e.target.classList.add('is-painted');
        ioQuote.unobserve(e.target);
      }
    });
  }, { rootMargin: '0px 0px 0px 0px', threshold: 0.05 });

  function observeCitations(){
    setupCitationPaint();
    document.querySelectorAll('.one-citation__quote').forEach(function(q){
      // Si déjà visible au chargement, déclenche tout de suite
      var rect = q.getBoundingClientRect();
      if (rect.top < window.innerHeight && rect.bottom > 0) {
        setTimeout(function(){ q.classList.add('is-painted'); }, 200);
      } else {
        ioQuote.observe(q);
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeCitations);
  } else {
    observeCitations();
  }
})();
